<template>
  <v-select
    v-bind="$attrs"
    v-on="$listeners"
    :items="items"
    item-value="id"
    :data-testid="dataTestid"
  />
</template>

<script>
export default {
  props: {
    "data-testid": {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      items: [{id: false,text: "Loi 1908"},{id: true,text: "Coopérative"}],
    };
  },
};
</script>
